import React from 'react';
import { PrinterIcon, ScissorsIcon, HeartHandshakeIcon } from 'lucide-react';
const items = [{
  label: 'Print',
  Icon: PrinterIcon
}, {
  label: 'Cut',
  Icon: ScissorsIcon
}, {
  label: 'Share',
  Icon: HeartHandshakeIcon
}];
export function PrintCutShare() {
  return <p className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-navy" aria-label="Print, cut, share" data-id="element-193" data-mp="12hq60pbhtsn7">
      {items.map(({
      label,
      Icon
    }, i) => <React.Fragment key={label} data-id="element-194" data-mp="204xgqva1obxv" data-mpi={i}>
          {i > 0 && <span className="text-gold" aria-hidden="true" data-id="element-195" data-mp="1v6npuwvcrxi2">•</span>}
          <span className="inline-flex items-center gap-1.5 text-sm font-extrabold uppercase tracking-[0.16em] sm:text-base" data-id="element-196" data-mp="1v8guy7qbi9ny">
            <Icon className="h-4 w-4 text-coral sm:h-5 sm:w-5" aria-hidden="true" data-id="element-197" data-mp="1lgubxp7qn6an" />
            {label}
          </span>
        </React.Fragment>)}
    </p>;
}